export enum ApplicationSourcesEnum {
  SELF = "SELF",
  ANT = "ANT",
}
